import { render, staticRenderFns } from "./collectionManage.vue?vue&type=template&id=d0cc7c9c"
import script from "./collectionManage.vue?vue&type=script&lang=js"
export * from "./collectionManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports